import { fmtDate } from '@dcc-erp/shared';
import type { LvaEventType, LvaMovementListRow } from '@dcc-erp/shared';

import { movementApproverDisplay } from './movement-display';

// Presentational company-wide movement table for the Movement tab. DOM matches
// the original prototype table (9 columns, `code`/`muted` cell classes); the
// badge tones are the LvaEventType analogue of the old TYPE_BADGE map.
interface BadgeMeta {
  l: string;
  c: string;
}

const TYPE_BADGE: Record<LvaEventType, BadgeMeta> = {
  TRANSFER: { l: 'โอนระหว่างหน่วยงาน', c: 'info' },
  REASSIGN_CUSTODIAN: { l: 'เปลี่ยนผู้ถือครอง', c: 'info' },
  MARK_DAMAGED: { l: 'ชำรุด', c: 'warning' },
  MARK_LOST: { l: 'สูญหาย', c: 'negative' },
  DISPOSE: { l: 'จำหน่าย', c: 'neutral' },
};

export function LvaMovementTable({ rows }: { rows: LvaMovementListRow[] }) {
  return (
    <table className="tbl">
      <thead>
        <tr>
          <th>วันที่</th>
          <th>เลขที่</th>
          <th>ประเภท</th>
          <th>LVA</th>
          <th>จาก</th>
          <th>ไป</th>
          <th>ผู้บันทึก</th>
          <th>ผู้อนุมัติ</th>
          <th>หมายเหตุ</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={9} className="muted" style={{ textAlign: 'center', padding: 24 }}>
              ยังไม่มีการเคลื่อนไหว
            </td>
          </tr>
        ) : (
          rows.map((m) => {
            const t = TYPE_BADGE[m.eventType] ?? { l: m.eventType, c: 'neutral' };
            const from = m.fromBranchName ?? m.fromCustodianName ?? '-';
            const to = m.toBranchName ?? m.toCustodianName ?? '-';
            return (
              <tr key={m.id}>
                <td>{fmtDate(m.eventDate)}</td>
                <td className="code">
                  <b>{m.code}</b>
                </td>
                <td>
                  <span className={`badge ${t.c}`}>{t.l}</span>
                </td>
                <td className="code">{m.lvaCode}</td>
                <td className="muted">{from}</td>
                <td className="muted">{to}</td>
                <td className="muted">{m.submittedBy}</td>
                <td className="muted">{movementApproverDisplay(m) ?? '-'}</td>
                <td className="muted">{m.reason ?? '-'}</td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
}
